//css-------------------
import "@/css/home/application.scss";
import "@/css/share/_reset.scss";
import "@/css/share/_base.scss";
import "@/css/share/_share.scss";
import "@/css/share/components/_loading.scss";
import "@/css/share/components/_lightbox.scss";
import "@/css/share/components/_header.scss";
import "@/css/share/components/_footer.scss";
import "@/css/share/components/_maintitle.scss";
import "@/css/share/components/_btn_row.scss";
import "@/css/share/components/_backtotop.scss";
import "@/css/share/components/_breadcrumbs.scss";
import "@/css/share/components/_input.scss";
import "@/css/share/components/_sec_title.scss";

//datepicker
import(/* webpackPrefetch: true */ "js-datepicker/dist/datepicker.min.css");


//fontawesome
import(/* webpackPrefetch: true */ "@/lib/fontawesome/css/fontawesome.min.css");
import(/* webpackPrefetch: true */ "@/lib/fontawesome/css/regular.min.css");

//components js-------------------
import(/* webpackPrefetch: true */ "@/js/share/components/_common_lazy");
import(/* webpackPrefetch: true */ "@/js/share/components/_font_family");
import( /* webpackPrefetch: true */ "@/js/share/components/_backtotop");
import { subnav_show, subnav_hide, subnav_toggle, m_menu_open } from "@/js/share/components/_header";
import { init_imageloaded } from "@/js/share/components/_imageloader.js";

//npm lib 
import { createApp } from "vue/dist/vue.esm-browser.prod.js";
import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit";
import datepicker from 'js-datepicker';


const app = createApp({
    data() {
        return {
            menu_open: false,
        };
    },
    watch: {
        menu_open: m_menu_open(this),
    },
    mounted() {
        const _this = this;

        init_imageloaded(function () {
            _this.datepicker_fn('.start');
            _this.datepicker_fn('.end');
        });

    },
    methods: {
        subnav_show,
        subnav_hide,
        subnav_toggle,
        datepicker_fn(element) {
            const _this = this;
            datepicker(element, {
                id: 1,
                customDays: ['日', '一', '二', '三', '四', '五', '六'],
                customMonths: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
                formatter: (input, date, instance) => {
                    _this.date_formatter(input, date, instance)
                },
            })
        },
        date_formatter(input, date, instance) {
            const isoString = date.toISOString();
            const formattedDate = isoString.split("T")[0];
            input.value = formattedDate // => 'yyyy-mm-dd'
        },
    },
}).mount("#app");
